import React from 'react';
import ShopEmptyState from '../SchoolShop/ShopEmptyState';
import { closedShopCopyFor } from './closedShopCopy';
import '../SchoolShop/SchoolShop.css';

/**
 * ClosedShopMessage — the localized "shop is closed, opens soon" block shown
 * wherever school-less shopping is blocked by the brand's "Disable Open Shop"
 * flag (MenuItemShop listing pages, bare configurators without a school).
 * Thin wrapper over ShopEmptyState with copy from closedShopCopy.
 *
 * Use `standalone` when rendering outside a `.school-shop__wrapper` container
 * (e.g. a blocked configurator page between Header and Footer).
 */
const ClosedShopMessage = ({ brandSlug, feSlug, standalone = false }) => {
  const copy = closedShopCopyFor(brandSlug);
  const empty = (
    <ShopEmptyState
      feSlug={feSlug}
      title={copy.title}
      text={copy.text}
      contactLabel={copy.contactLabel}
      faqLabel={copy.faqLabel}
    />
  );
  if (!standalone) return empty;
  return (
    <main className="school-shop__wrapper" style={{ padding: 'var(--space-ui-large-m) var(--layout-padding-mobile)' }}>
      {empty}
    </main>
  );
};

export default ClosedShopMessage;
